module.exports = __webpack_public_path__ + "img/sarah-p-wills.4aa66cc9.png";